<template>
  <v-row>
    <v-col cols="12" v-if="title">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        :title="title"
      />
    </v-col>

    <v-col cols="12" class="pt-0" v-if="existingFiles.length < limit">

<!--      <v-tooltip bottom nudge-top="25">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <div v-bind="attrs" v-on="on">-->

<!--          </div>-->
<!--        </template>-->
<!--        <span>Необходимо прикрепить файл</span>-->
<!--      </v-tooltip>-->

      <v-file-input
        v-model="files"
        accept="application/pdf"
        placeholder="Выберите файл"
        prepend-icon="mdi-paperclip"
        truncate-length="35"
        :loading="loading"
        :disabled="loading || disabled"
        multiple
        outlined
        rounded
        dense
        show-size
        @click="$v.files.$touch()"
        :error-messages="$errorMessages($v.files)"
      >
        <template v-slot:selection="{ file, index, text }">
          <v-chip color="blue" dark small close @click:close="removeFile(file)">
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>
    </v-col>

    <v-col cols="12" class="pt-0" v-if="existingFiles.length">
      <Title v-if="showTitleExistingFiles" text-start :font-weight="400" :font-size="14" title="Загруженные файлы"/>
      <v-chip
        class="mr-1" :class="showTitleExistingFiles && 'mt-1'"
        color="deep-purple accent-4"
        v-for="(file, i) in existingFiles"
        :key="i"
        dark close small
        @click:close="removeFile(file)"
      >
        {{ file.originalName }}
      </v-chip>
    </v-col>

  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import { fileApi } from "@/api";
import { maxLength } from 'vuelidate/lib/validators'
import _ from 'lodash'

export default {
  name: 'FileInput',

  components: {
    Title
  },

  props: {
    title:  String,

    refId: Number,

    refClassName: String,

    limit: {
      type: Number,
      default: 3
    },

    disabled: Boolean,

    showTitleExistingFiles: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      files: [],
      existingFiles: [],
      loading: false
    }
  },

  validations() {
    return {
      files: {
        fileType: props => {
          return props.length
            ? !props.some(item => item.type !== 'application/pdf')
            : true
        },
        fileSize: props => {
          return props.length
            ? !props.some(item => item.size > 3 * 1024 * 1024)
            : true
        },
        filesLimit: maxLength(this.limit)
      }
    }
  },

  // rules for single file
  // files: {
  //   fileType: (props) => {
  //     return props ? props?.type === 'application/pdf' : true
  //   },
  //   fileSize: (props) => {
  //     return props ? props?.size < 3 * 1024 * 1024 : true
  //   }
  // }

  methods: {
    async removeFile(file) {
      if (file.id) {
        try {
          await fileApi.deleteFile(file.id)
          this.existingFiles = this.existingFiles.filter(el => el.id !== file.id)
        } catch (e) {
          console.log(e)
          this.$toastr('error', e.status, `Ошибка удаления файла ${file.originalName}`)
        }
      } else {
        this.files = this.files.filter(el => el !== file)
      }
    },

    async getExistingFiles() {
      try {
        this.loading = true
        this.existingFiles = await fileApi.getFiles(this.refId, this.refClassName)
      } catch (e) {
        console.log(e)
        this.$toastr('error', e.status, 'Ошибка поиска загреженных файлов')
      } finally {
        this.loading = false
      }
    }
  },

  watch: {
    'refId': {
      immediate: true,
      async handler(value) {
        this.files = []
        this.existingFiles = []
        if (value) {
          await this.getExistingFiles()
        }
      }
    },

    'files.length': {
      handler() {
        this.$emit('set-files', { invalid: this.$v.$invalid, files: this.files })
      }
    }
  }
}
</script>

<style scoped>

</style>
